module.exports = __webpack_public_path__ + "static/media/Data_insight_en_2-2.85b77d2f.svg";